import React, { createContext, useState, FC, useEffect } from "react";
import Toaster from "../components/atoms/Toaster/toast";

export type TodosContextState = {
  alert: any;
  addAlert: (message: any, severity: any, alert: boolean) => void;
};

const contextDefaultValues: TodosContextState = {
  alert: {
    message: "",
    severity: "",
    alert: false,
  },
  addAlert: (message: any, severity: any, alert: boolean) => {},
};

interface Props {
  children: React.ReactNode;
}

export const TodosContext =
  createContext<TodosContextState>(contextDefaultValues);
const TodosProvider: React.FC<Props> = ({ children }) => {
  const [alert, setAlert] = useState(contextDefaultValues.alert);

  function addAlert(message: any, severity: any, alert: boolean) {
    setAlert({
      message: message,
      severity: severity,
      alert: alert,
    });
  }

  return (
    <TodosContext.Provider
      value={{
        alert,
        addAlert,
      }}
    >
      <Toaster alert={alert} />
      {children}
    </TodosContext.Provider>
  );
};

export default TodosProvider;
